<template>
  <nav class="flex gap-2 xl:gap-4">
    <RouterLink
      v-for="link in footerLinks"
      :key="link.path"
      :to="link.path"
      class="text-sm text-white xl:text-base"
    >
      {{ link.label }}
    </RouterLink>
  </nav>
</template>

<script lang="ts" setup>
const footerLinks = [
  { label: "이용약관", path: "/terms" },
  { label: "개인정보처리방침", path: "/privacy" },
];
</script>
